"use client";
import React, { useEffect, useState } from "react";
import Listing from "../../sections/ProductListing/Listing";
import MobileSortFilter from "../../components/MobileSortFilter";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useNavigationEvent } from "../hooks/useNavigationEvent";
import { useQuery } from "@tanstack/react-query";
import { fetchdependentFilterListing, fetchIndependentFilterListing, fetchPLPListing, fetchSeeMoreDependentFilters, fetchSeeMoreFilters } from "../apis/getApis";
import FiltersModal from "../../components/FiltersModal";
import { configureParams } from "../hooks/FiltersHook";
import useFiltersHook from "../hooks/useFiltersHook";

interface filters {
  [key: string]: any;

}

interface filtersVal {
  filterIndDpendentFilters: object

}



function ProductsListing() {
  // states
  const [mobileFilter, setMobileFilter] = useState<any>();
  const [isSandwichOpen, setisSandwichOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState<null | number>(1);
  const [sizeOfPages, setSizeOfPages] = useState(24);
  const [orderBy, setOrderBy] = useState({});
  const [filtersData, setFiltersData] = useState<any>([]);
  const [dependentFilters, setdependentFilters] = useState();
  //query params states
  const searchParams = useSearchParams();
  const [catCahnge, setCatCahnge] = useState(false);
  const [paramOBJ, setParamOBJ] = useState<any>();
  const [search, setSearch] = useState<string | any[]>("");
  const [priceRange, setPriceRange] = useState<any>();
  const [catId, setCatId] = useState();
  const [SeeMoreModal, setSeeMoreModal] = useState(false);
  const [seeMoreFiltersData, setSeeMoreFiltersData] = useState([]);
  const [filtersTitle, setFiltersTitle] = useState();
  const [filterObject, setfilterObject] = useState();
  const [seeMoreFunction, setseeMoreFunction] = useState<any>()
  const filterVAl: any = useFiltersHook(filtersData, dependentFilters, search, priceRange, orderBy, currentPage, catId)
  const theParam = configureParams({
    filters: filterVAl,
    detectChange: catCahnge
  })


  useNavigationEvent();

  let fParam = theParam;

  const getFilters = useQuery({
    queryKey: ["filtersListing", filterVAl],
    queryFn: () => fetchIndependentFilterListing(fParam),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    onSuccess: (data) => {
      setFiltersData(data?.data?.body?.data);
    },
  });

  const getSeeMoreFiltersIndependent = useQuery({
    queryKey: ["SeeMoreFilters", [SeeMoreModal]],
    queryFn: () => seeMoreFunction,
    enabled: !!SeeMoreModal,
    refetchOnWindowFocus: false,
    cacheTime: 0,

    onSuccess: (data) => {

      setSeeMoreFiltersData(data?.data?.body?.data);
    },
  });

  const getItems = useQuery({
    queryKey: ["items", [currentPage, sizeOfPages, filterVAl,]],
    queryFn: () => fetchPLPListing(currentPage, sizeOfPages, fParam),
    enabled: !!filterVAl,
    refetchOnWindowFocus: false,
  });




  const getdependentFilters = useQuery({
    queryKey: ["Dependentfilters", catId, filterVAl],
    queryFn: () => fetchdependentFilterListing(catId, catId ? fParam : ""),
    enabled: !!catId,
    refetchOnWindowFocus: false,
    cacheTime: 0,

    onSuccess: (data) => {
      setdependentFilters(data?.data?.body?.data);
    },
  });


  // let sideeffects of independent filters
  useEffect(() => {

    setCatId(filterVAl.filterIndDpendentFilters?.hasOwnProperty("category") ? filterVAl.filterIndDpendentFilters.category[0].id : Number(paramOBJ?.category_id));
    if (catCahnge === false) {
      setSearch(searchParams.get("search"));
      setCurrentPage(searchParams.get("page") ? Number(searchParams.get("page")) : 1);
      setSizeOfPages(searchParams.get("size") ? Number(searchParams.get("size")) : 24);
      setPriceRange(
        { from: searchParams.get("priceFrom"), to: searchParams.get("priceTo") }
      );
    }

  }, [filtersData, searchParams]);

  // useEffect(() => { getFilters.refetch() }, [searchParams])


  //  page change effects and filters effects
  useEffect(() => {
    setNoOfPages(getItems?.data?.data.body?.paginationInfo?.totalPages);
    if (catCahnge) {

      window.history.pushState({}, "", window.location.pathname + "?" + theParam)
    }
  }, [getItems?.data?.data?.body?.data, sizeOfPages, filterVAl, searchParams]);

  const changePage = (page: any) => {
    setCurrentPage(page);
    window.scrollTo(0, 500);
    setCatCahnge(true)
  };

  const removeDependentFiltersParam = (obj: any) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key].hasOwnProperty("values")) {
        obj[key].values.forEach((item: any) => {
          item.isChecked = false;
        });
      }
    }
    setdependentFilters(obj);
  };
  // see more
  const seeMoreFilters = (title: any, val: any) => {
    setSeeMoreModal(true);
    setFiltersTitle(title);
    setfilterObject(val);
    if (title === "depenedent") {
      setseeMoreFunction(fetchSeeMoreDependentFilters(catId, val, fParam))
    } else {
      setseeMoreFunction(fetchSeeMoreFilters(val, fParam))
    }
  };

  const clearIndependentFilters = () => {
    setFiltersData((prev: any) => {
      return Object.entries(prev).reduce(
        (oldFilters: any, [fKey, fValue]: any) => {
          return {
            ...oldFilters,
            [fKey]: {
              ...fValue,
              values: fValue.values.reduce((oldValue: any, value: any) => {
                return [...oldValue, { ...value, isChecked: false }];
              }, []),
            },
          };
        },
        {}
      );
    });
  }
  const clearDependentFilters = () => {

    setdependentFilters((prev: any) => {
      if (prev) {
        return Object.entries(prev).reduce(
          (oldFilters: any, [fKey, fValue]: any) => {

            return {
              ...oldFilters,
              [fKey]: {
                ...fValue,
                values: fValue.values.reduce((oldValue: any, value: any) => {
                  return [...oldValue, { ...value, isChecked: false }];
                }, []),
              },
            };
          },
          {}
        );

      }
    });
  }



  return (
    <>
      {/* <Meta title="Mobile, Laptop, Tab, Desktop, Accessories, LED's" /> */}
      <div className="lg-none md-block sm-block d-block">
        <MobileSortFilter
          search={search}
          setCatChange={setCatCahnge}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          setMobileFilter={setMobileFilter}
          mobileFilter={mobileFilter}
          Labels={[
            { label: "High to Low", value: "desc", key: "price" },
            { label: "Low to High", value: "asc", key: "price" },
            { label: "Discount Low to High", value: "asc", key: "discount" },
            { label: "Discount Hight to Low", value: "desc", key: "discount" },


          ]}
        />
      </div>

      <main>
        {/* <Filters /> */}
        <Listing
          setisSandwichOpen={setisSandwichOpen}
          isSandwichOpen={isSandwichOpen}
          dependentFilters={dependentFilters}
          setCatCahnge={setCatCahnge}
          setOrderBy={setOrderBy}
          orderBy={orderBy}
          filtersData={filtersData}
          setfiltersData={setFiltersData}
          noOfPages={noOfPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          changePage={changePage}
          shopItems={getItems?.data?.data?.body?.data}
          setMobileFilter={setMobileFilter}
          getFilters={getFilters}
          setdependentFilters={setdependentFilters}
          totalItems={getItems?.data?.data?.body?.paginationInfo?.totalItems}
          sizeOfPages={sizeOfPages}
          setSizeOfPages={setSizeOfPages}
          setPriceRange={setPriceRange}
          setSearch={setSearch}
          search={search}
          priceRange={priceRange}
          filters={filterVAl}
          removeDependentFiltersParam={removeDependentFiltersParam}
          seeMoreFilters={seeMoreFilters}
          catId={catId}
          clearDependentFilters={clearDependentFilters}
          getItems={getItems}
        />
        <FiltersModal
          loading={getSeeMoreFiltersIndependent.isLoading}
          setdependentFilters={setdependentFilters}
          dependentFilters={dependentFilters}
          setCatCahnge={setCatCahnge}
          filterObject={filterObject}
          setFiltersData={setFiltersData}
          filtersData={filtersData}
          filtersTitle={filtersTitle}
          seeMoreFiltersData={seeMoreFiltersData}
          setSeeMoreFiltersData={setSeeMoreFiltersData}
          show={SeeMoreModal}
          onHide={() => setSeeMoreModal(false)}
          title="sdfsd"
        />

      </main>
    </>
  );
}

export default ProductsListing;
